import React, { Fragment, useEffect, useRef, useState } from 'react';
import styles from '../../styles/modules/common/media.module.scss'
type Props = {
    onBottomHit: () => void;
    isLoading: boolean;
    hasMoreData: boolean;
    loadOnMount: boolean;
  };

function isBottom(ref: React.RefObject<HTMLDivElement>) {
    if (!ref.current) {
      return false;
    }
    return ref.current.getBoundingClientRect().bottom <= window.innerHeight;
  }
  
  const InfiniteScroll: React.FC<Props> = ({
    onBottomHit,
    isLoading,
    hasMoreData,
    loadOnMount,
    children,
  }) => {
    const [initialLoad, setInitialLoad] = useState(true);
    const contentRef = useRef<HTMLDivElement>(null);
  
    useEffect(() => {
      if (loadOnMount && initialLoad && hasMoreData) {
        onBottomHit();
        setInitialLoad(false);
      }
    }, [onBottomHit, loadOnMount, initialLoad]);
  
    useEffect(() => {
      const onScroll = () => {
        if (!isLoading && hasMoreData && isBottom(contentRef)) {
          onBottomHit();
        }
      };
      document.addEventListener('scroll', onScroll);
      return () => document.removeEventListener('scroll', onScroll);
    }, [onBottomHit, isLoading, hasMoreData]);
  
    return ( <Fragment><div ref={contentRef}> {children}</div> 
        <div>{isLoading ? <div className={`${styles.news__loader}`}></div> : ""}</div>
        </Fragment>
        )
  };

  export default InfiniteScroll;